'use client';
import { getCId, getVid, getTrackingParams, getUId } from '@coverright/utils';

let posthogPromise: Promise<(typeof import('posthog-js'))['default']> | null = null;
const loadPosthog = () => {
  if (!posthogPromise) {
    posthogPromise = import('posthog-js').then(m => m.default);
  }
  return posthogPromise;
};


export const logEvent = (eventName: string, params?: TrackingEvent) => {
  return new Promise(resolve => {
    const sendEvent = (cId?: string) => {
      const data: any = {
        c_id: cId,
        uId: getUId(),
        product: (window as any).product,
        version: (window as any).version,
        page: document.location.href,
        page_canonical: document.location.origin + document.location.pathname,
        page_title: document.title,
        event_type: eventName,
        ...flatten(getTrackingParams()),
        ...params
      };

      trackEvent(eventName, data)
    }


    let cId = getVid();

    if (cId) {
      sendEvent(cId);
      resolve(true);
    } else {
      let count = 0;

      const interval = setInterval(() => {

        cId = getVid();

        if (cId || count > 10) {
          if (!cId) {
            cId = (window as any).c_id || getCId();
          }
          sendEvent(cId);
          clearInterval(interval);
          resolve(true);
        }

        count++;
      }, 500)
    }


  })
}

function trackEvent(eventName: string, data: any) {
  if (window && !(window as any)['Cypress']) {
    if ((window as any)['track']) {
      loadPosthog().then(posthog => {
        if (posthog.get_distinct_id()) {
          posthog.capture(eventName, data);
        }
      });
      (window as any).track(eventName, data)
    } else {
      console.log('DEVELOP', eventName, data);
    }
  }
}

export interface TrackingEvent {
  c_id?: string,
  page?: string,
  product?: string,
  page_title?: string,
  element_title?: string,
  element_id?: string,
  [key: string]: any,
}

function traverseAndFlatten(currentNode: any, target: any, flattenedKey?: string) {
  for (const key in currentNode) {
    // eslint-disable-next-line no-prototype-builtins
    if (currentNode.hasOwnProperty(key)) {
      let newKey;
      if (flattenedKey === undefined) {
        newKey = key;
      } else {
        newKey = flattenedKey + '.' + key;
      }

      const value: any = currentNode[key];
      if (typeof value === "object") {
        traverseAndFlatten(value, target, newKey);
      } else {
        target[newKey] = value;
      }
    }
  }
}

function flatten(obj: any) {
  const flattenedObject = {};
  traverseAndFlatten(obj, flattenedObject);
  return flattenedObject;
}
